export default __webpack_public_path__ + "static/media/HUGO-04.9d66d789.png";